export const FACULTY_MAP = {
    ETF: 'Elektrotehnički fakultet',
    PMF: 'Prirodno-matematički fakultet',
    TEHNIČKI_FAKULTET: 'Pripremna nastava iz matematike za upis na tehničke fakultete',
    PRVA_GODINA: 'Pripremni kurs iz matematike za prvu godinu tehničkih fakulteta',
};
export const getRequiredError = (value) => `Molimo unesite ${value} kako biste nastavili dalje.`;